import React from "react";
import { useRouter } from "@src/lib/router";
import QrPaymentCheckout from "@src/components/checkoutPage/components/QrPayment/QrPayment";

const QrCheckoutPage = () => {
  const router = useRouter();
  const {imageUrl, gatewayOrderId } = router.query;

  if(!router.isReady){
    return null
  }
  return <QrPaymentCheckout imageUrl={imageUrl} gatewayOrderId={gatewayOrderId}/>;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
QrCheckoutPage.getLayoutProps = () => ({
  accent: true,
  noFooter: true,
  noHeader: true,
  noPullToRefresh: true,

});

export default QrCheckoutPage;
